export default __webpack_public_path__ + "static/media/plusSolid.14fe6c21.svg";